import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Pagination from 'react-js-pagination';
import Select from 'react-select';
import ReactToPrint from 'react-to-print';

let verificationStatusData = [
    {
        label: 'Verified',
        value: 'verified'
    },
    {
        label: 'Newly found',
        value: 'newly found'
    }
];

class ScannedResourceReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All stock verification data
            scannedResourceListLoading: false,
            totalScannedResourceListItems: 0,
            scannedResourceList: {},
            pageIndex: 1,
            limit: "10",

            // report filter
            searchByStockVerification: '',
            searchByScannedBy: '',
            searchByAccessionNumber: '',
            searchByScannedFromDate: '',
            searchByScannedToDate: '',
            searchByVerificationStatus: '',
            searchFacultyName: '',

            stockVerificationList: {},
            stockVerificationLoading: false,

            scannedByList: {},
            loadingScannedBy: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Verification Status", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: "Accession Number", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Resource Medium", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Invoice Number", isVisible: true },
                { name: "Resource Status", isVisible: true },
                { name: "Scanned By", isVisible: true },
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Verification Status", key: 'verificationStatus' },
                { name: "Accession Series", key: 'accessionSeries' },
                { name: "Accession Number", key: 'accessionNumber' },
                { name: "Title", key: 'title' },
                { name: "Resource Medium", key: 'resourceMedium' },
                { name: "Author", key: 'author' },
                { name: "Invoice Number", key: 'invoiceNumber' },
                { name: "Resource Status", key: 'resourceStatus' },
                { name: "Scanned By", key: 'scannedBy' }
            ],

            exportItemVisibility: [
                { name: "Verification Status", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: "Accession Number", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Resource Medium", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Invoice Number", isVisible: true },
                { name: "Resource Status", isVisible: true },
                { name: "Scanned By", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],

            //advance filter modal
            advanceFilterModal: false,
        };
    }

    componentDidMount() {
        this.getDashboardStockVerification();  // report list
        this.getFacultyList();
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF Stock Verification
    getDashboardStockVerification = async () => {
        this.setState({
            stockVerificationLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getDashboardStockVerification',
            requestData,
            '/api/library/stockVerification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getDashboardStockVerification()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            stockVerificationList: apiResult.data,
                            stockVerificationLoading: false
                        });
                    } else {
                        this.setState({
                            stockVerificationList: {},
                            stockVerificationLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        stockVerificationList: {},
                        stockVerificationLoading: false
                    });
                }
            }
        }
    }

    // scanned resource report list
    getStockVerificationScannedResourceList = async () => {
        this.setState({
            stockVerificationLoading: true
        });

        let filterData = {
            'accessionsSeries': this.state.searchByAccessionNumber,
            'scanned_by': this.state.searchByScannedBy.value,
            'verificationStatus': this.state.searchByVerificationStatus,
            'fromDate': this.state.searchByScannedFromDate,
            'toDate': this.state.searchByScannedToDate
        }

        let requestData = {
            'iid': config.institute_id,
            'uniqueId': this.state.searchByStockVerification.value,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'filterData': filterData
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getStockVerificationScannedResourceList',
            requestData,
            '/api/library/stockVerification.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getDashboardStockVerification()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            scannedResourceList: apiResult.data,
                            totalScannedResourceListItems: apiResult.totalCount,
                            stockVerificationLoading: false
                        });
                    } else {
                        this.setState({
                            scannedResourceList: {},
                            totalScannedResourceListItems: 0,
                            stockVerificationLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        scannedResourceList: {},
                        totalScannedResourceListItems: 0,
                        stockVerificationLoading: false
                    });
                }
            }
        }
    }

    //API CALL METHOD TO LIST OF faculty
    getFacultyList = async () => {
        this.setState({
            loadingScannedBy: true
        });

        let requestData = {
            'iid': config.institute_id,
            'type': 'all',
            'page_index': this.state.pageIndex,
            'limit': this.state.limit,
            'search': this.state.searchFacultyName
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getFacultyList',
            requestData,
            '/api/instructor/facultyRegistration.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getFacultyList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            scannedByList: apiResult.data,
                            loadingScannedBy: false
                        });
                    } else {
                        this.setState({
                            scannedByList: {},
                            loadingScannedBy: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        scannedByList: {},
                        loadingScannedBy: false
                    });
                }
            }
        }
    }

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({
            pageIndex: 1, limit: event.target.value, searchByStockVerification: this.state.searchByStockVerification, searchByScannedBy: this.state.searchByScannedBy, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByScannedFromDate: this.state.searchByScannedFromDate, searchByScannedToDate: this.state.searchByScannedToDate, searchByVerificationStatus: this.state.searchByVerificationStatus
        }, () => {
            this.getStockVerificationScannedResourceList();
        });
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByStockVerification: this.state.searchByStockVerification, searchByScannedBy: this.state.searchByScannedBy, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByScannedFromDate: this.state.searchByScannedFromDate, searchByScannedToDate: this.state.searchByScannedToDate, searchByVerificationStatus: this.state.searchByVerificationStatus }, () => {
            this.getStockVerificationScannedResourceList();
        });
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByStockVerification: '', searchByScannedBy: '', searchByAccessionNumber: '', searchByScannedFromDate: '', searchByScannedToDate: '', searchByVerificationStatus: ''
            , limit: "10", pageIndex: 1, scannedResourceList: {}
        }, () => {
            this.getStockVerificationScannedResourceList();
        }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterStockVerification = Object.entries(this.state.stockVerificationList)
            ?.filter(([id, data]) => id == this.state.searchByStockVerification.value)
            .map(([id, data]) => data.stock_verification_name)
        let filterScannedFromDate = this.state.searchByScannedFromDate
        let filterScannedToDate = this.state.searchByScannedToDate
        let filterAccessionNo = this.state.searchByAccessionNumber
        let filterVerificationStatus = this.state.searchByVerificationStatus
        let filterScannedBy = this.state.searchByScannedBy

        if (this.state.searchByStockVerification && filterStockVerification.length > 0) {
            FilterArray.push(`Stock Verification - ${filterStockVerification[0]}`)
        }

        if (filterScannedFromDate) {
            FilterArray.push(`Scanned From Date - ${filterScannedFromDate}`)
        }

        if (filterScannedToDate) {
            FilterArray.push(`Scanned To Date - ${filterScannedToDate}`)
        }

        if (filterScannedBy) {
            FilterArray.push(`Scanned By - ${filterScannedBy.label}`)
        }

        if (filterAccessionNo) {
            FilterArray.push(`Accession Number - ${filterAccessionNo}`)
        }

        if (filterVerificationStatus) {
            FilterArray.push(`Verification Status - ${filterVerificationStatus}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllScannedResourceReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                Scanned Resources Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="8" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Verification Status</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Accession Series</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Accession Number</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Resource Medium</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Author</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Invoice Number</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Resource Status</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Scanned By</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="8">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.verification_status || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.accessionSeries || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.medium || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.author || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.invoiceNo || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.resourceStatus || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.added_by_name + "|" + resource?.added_datetime || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="8">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalScannedResourceListItems } = this.state;
        const totalPages = Math.ceil(totalScannedResourceListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let filterData = {
                'accessionsSeries': this.state.searchByAccessionNumber,
                'scanned_by': this.state.searchByScannedBy.value,
                'verificationStatus': this.state.searchByVerificationStatus,
                'fromDate': this.state.searchByScannedFromDate,
                'toDate': this.state.searchByScannedToDate
            }

            let requestData = {
                'iid': config.institute_id,
                'uniqueId': this.state.searchByStockVerification.value,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'filterData': filterData
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'getStockVerificationScannedResourceList',
                requestData,
                '/api/library/stockVerification.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalCount,
                    }, () => {

                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div style={{ display: this.state.advanceFilterModal ? 'flex' : 'none' }} id="reportsSideMenu">
                <div id="reportDataContainer">
                    {/* Modal Header */}
                    <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                        <h6 className="modal-title">
                            {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px', color: '#fff' }} /> */}
                            <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                            Advanced Filter
                        </h6>
                        <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ advanceFilterModal: false }) }} style={{ cursor: "pointer" }} />
                    </div>

                    {/* Modal Content */}
                    {/* className="custom-form-body" style={{ padding: '10px', overflowY: 'auto', maxHeight: '60vh' }} */}
                    <div className='col-md-12 pt-2 pb-3'>
                        {/* Form Group: Accession number and verification status*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Accession Number</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <img
                                        src={searchPng}
                                        style={{
                                            position: 'absolute',
                                            left: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#ccc',
                                            backgroundColor: 'white',
                                            width: '15px',
                                            height: '15px',
                                            zIndex: 1,
                                        }}
                                    />
                                    <input
                                        type="text"
                                        className="form-control formControlAutoTask"
                                        id="searchByAccessionNoFilter"
                                        placeholder="Accession Number"
                                        style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                        value={this.state.searchByAccessionNumber}
                                        onChange={(event) => {
                                            this.setState({
                                                searchByAccessionNumber: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Verification Status</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <select
                                        className="form-control formControlContentTask"
                                        style={{
                                            // width: 'auto',
                                            width: '165px',
                                            height: '42px',
                                            fontSize: "12px",
                                            fontWeight: 400,
                                            lineHeight: '20px',
                                            fontFamily: "'Poppins', sans-serif",
                                            color: '#808080',
                                            borderRadius: '7px'
                                        }}
                                        onChange={(event) => {
                                            this.setState({
                                                searchByVerificationStatus: event.target.value || '', // Handle empty selection
                                            });
                                        }}
                                        value={this.state.searchByVerificationStatus} // Bind dropdown value to state
                                    >
                                        <option value={""}>Select Status</option>
                                        {verificationStatusData.map((member) => (
                                            <option key={member?.value} value={member?.value}>
                                                {member?.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer" style={{ padding: '20px 25px' }}>
                        <button
                            className="btn custom-btn"
                            style={{ fontSize: '14px', borderRadius: '7px' }}
                            // borderColor: '#0465AC !important'
                            onClick={() => {

                                this.setState({
                                    advanceFilterModal: false, searchByStockVerification: '', searchByScannedBy: '', searchByAccessionNumber: '', searchByScannedFromDate: '', searchByScannedToDate: '', searchByVerificationStatus: '',
                                    limit: "10", pageIndex: 1, scannedResourceList: {}
                                })
                            }}
                        >
                            Clear
                        </button>
                        <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                            this.setState({ advanceFilterModal: false }, () => {
                                this.getStockVerificationScannedResourceList();
                            })
                        }}>
                            Apply
                        </button>
                    </div>
                </div>
            </div >
        );
    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterStockVerification = Object.entries(this.state.stockVerificationList)
            ?.filter(([id, data]) => id == this.state.searchByStockVerification.value)
            .map(([id, data]) => data.stock_verification_name)
        let filterScannedFromDate = this.state.searchByScannedFromDate
        let filterScannedToDate = this.state.searchByScannedToDate
        let filterAccessionNo = this.state.searchByAccessionNumber
        let filterVerificationStatus = this.state.searchByVerificationStatus
        let filterScannedBy = this.state.searchByScannedBy

        if (this.state.searchByStockVerification && filterStockVerification.length > 0) {
            FilterArray.push(`Stock Verification - ${filterStockVerification[0]}`)
        }

        if (filterScannedFromDate) {
            FilterArray.push(`Scanned From Date - ${filterScannedFromDate}`)
        }

        if (filterScannedToDate) {
            FilterArray.push(`Scanned To Date - ${filterScannedToDate}`)
        }

        if (filterScannedBy) {
            FilterArray.push(`Scanned By - ${filterScannedBy.label}`)
        }

        if (filterAccessionNo) {
            FilterArray.push(`Accession Number - ${filterAccessionNo}`)
        }

        if (filterVerificationStatus) {
            FilterArray.push(`Verification Status - ${filterVerificationStatus}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Stock verification */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Stock Verification<span className='text-danger'>*</span></label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    options={Object.keys(this.state.stockVerificationList).map((key) => ({
                                                                        label: this.state.stockVerificationList[key].stock_verification_name,  // Use stock_verification_name as the label
                                                                        value: key  // Use the key (ID) as the value
                                                                    }))}
                                                                    value={this.state.searchByStockVerification}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByStockVerification: event || [], // Handle empty selection
                                                                        }, () => this.getStockVerificationScannedResourceList());
                                                                    }}
                                                                    placeholder="Select Stock Verification Name"
                                                                    isClearable
                                                                    isLoading={this.state.stockVerificationLoading} // Show loading spinner while fetching
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: 400,
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: 400,
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.stockVerificationLoading ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On scanned from date */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Scanned From Date</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Select Scanned From Date"
                                                                    value={this.state.searchByScannedFromDate}
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByScannedFromDate: event.target.value || '', // Handle empty selection
                                                                        }, () => this.getStockVerificationScannedResourceList()
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On scanned to date*/}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Scanned To Date</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                                                    placeholder="Select Scanned To Date"
                                                                    value={this.state.searchByScannedToDate}
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByScannedToDate: event.target.value || '', // Handle empty selection
                                                                        }, () => this.getStockVerificationScannedResourceList()
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On scanned by*/}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Scanned By</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    options={Object.keys(this.state.scannedByList).map((key) => ({
                                                                        label: this.state.scannedByList[key].faculty_fname + ' ' + this.state.scannedByList[key].faculty_lname,  // Use stock_verification_name as the label
                                                                        value: this.state.scannedByList[key].faculty_id // Use the key (ID) as the value
                                                                    }))
                                                                    }
                                                                    value={this.state.searchByScannedBy}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByScannedBy: event || [], // Handle empty selection
                                                                        }, () => this.getStockVerificationScannedResourceList());
                                                                    }}
                                                                    onInputChange={(inputValue) => {
                                                                        this.setState({ searchFacultyName: inputValue }, () => {
                                                                            this.getFacultyList(); // Trigger the API call after updating the search term
                                                                        }, 200);
                                                                    }}
                                                                    placeholder="Select Scanned By"
                                                                    isLoading={this.state.loadingScannedBy} // Show loading spinner while fetching
                                                                    isClearable
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: 400,
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: 400,
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                        singleValue: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.loadingScannedBy ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Select "Stock Verification" to get Scanned Resources Report filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>

                                        {Object.keys(this.state.scannedResourceList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="scannedResourceReport"
                                                                    filename="ScannedResourceReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllScannedResourceReport"   // export all functionality
                                                                    filename="ExportAllScannedResourceReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: {} }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByStockVerification !== '' || this.state.searchByScannedBy !== '' || this.state.searchByAccessionNumber !== '' ||
                                    this.state.searchByScannedFromDate !== '' || this.state.searchByScannedToDate !== '' || this.state.searchByVerificationStatus !== ''
                                ) &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Scanned Resources Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="scannedResourceReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" style={{ textAlign: 'center' }}>
                                                        Scanned Resources Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="8" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Verification Status</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Accession Series</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Accession Number</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Resource Medium</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Author</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Invoice Number</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Resource Status</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Scanned By</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.scannedResourceListLoading ?
                                                    <tr>
                                                        <td colSpan="8">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    Object.keys(this.state.scannedResourceList).length > 0 ?
                                                        (Object.values(this.state.scannedResourceList).map((resource, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.verification_status || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.accessionSeries || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.title || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.medium || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.author || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.invoiceNo || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.resourceStatus || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.added_by_name + "|" + resource?.added_datetime || ""}</td>}
                                                                </tr>
                                                            )
                                                        })) :
                                                        <tr>
                                                            <td colSpan="8">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.scannedResourceList).length > 0 || Object.keys(this.state.scannedResourceList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalScannedResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalScannedResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {
                            this.returnAdvanceFilterModelData()
                        }
                    </div >
                </div>
            </div >

        );
    }
}


export default ScannedResourceReport;